export { rocConfig } from './universal-config';
export { appConfig } from './universal-config';
export createRoutes from './create-routes';
export createStore from './flux/create-store';
export defaultReducers from './flux/reducers';
export defaultMiddlewares from './flux/middlewares';



/** WEBPACK FOOTER **
 ** ./~/roc-package-web-app-react/app/shared/index.js
 **/